<script setup lang="ts">
  defineOptions({ name: 'EmCardHeader' })
</script>

<template>
  <div class="emerald-card__header">
    <slot />
  </div>
</template>
